import React from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import LoginForm from '../components/form/LoginForm'
import LoggedOutLayoutWrapper from '../components/layout/LoggedOutLayoutWrapper'
import { Helmet } from 'react-helmet'
import { GOOGLE_LOGIN_ENABLED, GOOGLE_OAUTH_CLIENT_ID } from '../env'

const Login: React.FC = () => {
  return (
    <LoggedOutLayoutWrapper>
      <Helmet>
        <title>Powerspace Ads - Non intrusive advertising platform</title>
      </Helmet>
      {GOOGLE_LOGIN_ENABLED ? (
        <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
          <LoginForm />
        </GoogleOAuthProvider>
      ) : (
        <LoginForm />
      )}
    </LoggedOutLayoutWrapper>
  )
}

export default Login
